// متابعة العملاء (components/inbox/followups.tsx) — المالك 2026-10-22.
const EN_B15: Record<string, string> = {
  "متابعة العملاء": "Customer follow-ups",
  "متابعة العميل": "Follow up customer",
  "المتابعة": "Follow-up",
  "اليوم": "Today",
  "بكرة": "Tomorrow",
  "أمس": "Yesterday",
  "بعد ساعة": "In an hour",
  "بكرة الصبح": "Tomorrow morning",
  "بعد يومين": "In two days",
  "الأسبوع الجاي": "Next week",
  "حفظ": "Save",
  "تمت": "Done",
  "أجّل": "Snooze",
  "تمت المتابعة؟": "Follow-up done?",
  "✓ تمت المتابعة": "✓ Follow-up done",
  "صار رد بعد الموعد — تمت المتابعة؟": "There was a reply after the due time — follow-up done?",
  "لا توجد متابعات — أضفها من قائمة ⋮ في المحادثة": "No follow-ups — add one from the ⋮ menu in a conversation",
  "ملاحظة (اختياري): مثلاً ينتظر عرض سعر": "Note (optional): e.g. waiting for a quote",
  "تعذّر تنفيذ الإجراء": "Could not complete the action",
};
export default EN_B15;
